
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/[...alias]",
      function () {
        return require("private-next-pages/section/[...alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/[...alias]"])
      });
    }
  